import React, { createContext, useContext, useMemo, useState } from "react";

import { FiltersContextProps, FiltersContextValues } from "../types/contexts";
import { Filters } from "../types/games";
import initFilters from "../lib/initFilters";

const FiltersContext = createContext<FiltersContextValues | null>(null);

export const useFiltersContext = () => {
    const context = useContext(FiltersContext);
    if (!context) {
        throw new Error(
            "useFiltersContext must be used within a FiltersProvider",
        );
    }
    return context;
};

export const FiltersProvider: React.FC<FiltersContextProps> = props => {
    const { children } = props;

    const [filters, setFilters] = useState<Filters>(initFilters([]));

    const contextValue = useMemo(
        () => ({
            filters,
            setFilters,
        }),
        [filters],
    );

    return (
        <FiltersContext.Provider value={contextValue}>
            {children}
        </FiltersContext.Provider>
    );
};
